// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3sHTy","content":"GlobalSearch_content__19Py1"};